import { Box, Button, Grid, HStack, Heading, Image, Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import cursor from '../../../assets/images/cursor.png'
import Slidebar from '../Slidebar'
import { RiDeleteBin7Fill } from 'react-icons/ri'
import CourseModal from './CourseModal'
const AdminCourses = () => {
  const courses=[
    {
_id:"asdfdasfasd",
title:"Sahil course",
category:"Web development",
poster:{
  url:"https://i.pinimg.com/1200x/c6/c1/64/c6c164e07772ff2a09866989ac06eedd.jpg"
},
CreatedBy:"sahiltiwari1222@gmail.com",
views:123,
numOfVideos:3
    }
  ]
  const {isOpen,onClose,onOpen}=useDisclosure()
  const courseDetailsHandler=userId=>{
onOpen()
  }
  const deleteButtonHandler=userId=>{
    console.log(userId)
  }
  
  return (
    <Grid minH={'100vh'} css={{cursor:`url(${cursor}),default`}} templateColumns={['1fr','5fr 1fr']}>
    <Box p={['0','16']} overflowX='auto' >
<Heading textTransform={'uppercase'} children="All Users" my='16' textAlign={['center','left']}  />
<TableContainer w={['100vw','full']}>
  <Table variant={'simple'} size='lg' >
    <TableCaption>All available courses in the databse</TableCaption>

    <Thead>
      <Tr>
<Th>Id</Th>
<Th>Poster</Th>
<Th>Title</Th>
<Th>Category</Th>
<Th>Creator</Th>
<Th isNumeric>Views</Th>
<Th isNumeric>Lectutes</Th>
<Th isNumeric>Action</Th>
<Heading/>

      </Tr>
    </Thead>

    <Tbody>

{
  courses.map(item=>(
    <Row courseDetailsHandler={courseDetailsHandler} deleteButtonHandler={deleteButtonHandler} key={item._id} item={item} />
  ))
}
    </Tbody>
  </Table>
</TableContainer>
<CourseModal isOpen={isOpen} onClose={onClose} />
    </Box>
    <Slidebar/>
</Grid>
  )
}

function Row({item,courseDetailsHandler,deleteButtonHandler}){
  return (
    <Tr>
<Td>{item._id}</Td>
<Td>

  <Image src={item.poster.url}  />
</Td>
<Td>{item.title}</Td>
<Td textTransform={'uppercase'}>{item.category}</Td>
<Td>{item.CreatedBy}</Td>
<Td isNumeric>{item.views}</Td>
<Td isNumeric>{item.numOfVideos}</Td>

<Td isNumeric>
  <HStack justifyContent={'flex-end'}>
<Button onChange={()=>courseDetailsHandler(item._id)} variant={'outline'} color="purple.500">Change Role</Button>
<Button onChange={()=>deleteButtonHandler(item._id)} color={'purple.600'}>
  Views Lecture
</Button>
  </HStack>
</Td>
    </Tr>
  )
}
export default AdminCourses